import { ConfigurePrinterPage } from '@justomx/atlas-components'
import { useSessionData } from 'hooks/session.hook'
import { usePrinter } from './Printer.hook'

const PrinterPage = () => {
  const { actions } = usePrinter()
  const { user, country, warehouse, logout } = useSessionData()

  return (
    <ConfigurePrinterPage
      title="Conectar impresora"
      onPrinterPageChange={actions.onPrinterPageChange}
      menuProps={{
        userName: user.firstName,
        userEmail: user.username,
        country,
        warehouseName: warehouse?.coreDescription || 'Pruebas',
        version: '13.0.1',
        menuItems: user.menuItems || [],
        onLogout: logout
      }}
    />
  )
}

export default PrinterPage
